import { useState } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Divider,
  IconButton,
  ListSubheader,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarContainer,
  GridToolbarFilterButton,
  useGridApiContext,
} from "@mui/x-data-grid-pro";
import { GridToolbarExportContainer } from "../../components/datagrid/GridToolbarExport";
import { useNavigate } from "react-router-dom";

import { SearchButton, SearchFab, getListToolbarFilterButtonSx} from "../../components/Buttons";
import { ActionMenu } from "../../components/datagrid/ActionMenu";
import { AdvancedSearchToolbarProps } from "../../components/datagrid/AdvancedSearchToolbar";
import { Actions } from "../../components/datagrid/DataGrid";
import { DisplayPreferences } from "../../components/datagrid/DisplayPreferences";
import { SearchField } from "../../components/datagrid/SearchField";
import CreateComponent from "./CreateComponent";
import { CreateMenuOption } from "../../components/datagrid/CreateMenu";
import { useDataGridStore } from "../../store/DataGrid";

interface PartsToolbarProps extends AdvancedSearchToolbarProps {
  advanceSearchClicked: boolean;
  setFilterObj:React.Dispatch<React.SetStateAction<any>>;
}

const GridToolbarExport = ({
  csvOptions,
  printOptions,
  setAction,

  // RESTORED 2026-09-03 (clobbered by 966a1c28) — see
  // components/datagrid/__tests__/SettingsMenuExtrasForks.test.tsx. Destructured
  // here so it does not ride `...other` onto the kebab button's DOM node. The
  // param object is annotated `any` (the idiom certificates/ and freight/
  // already used) so adding a name here cannot make the others required.
  settingsMenuExtras,
  ...other
}: any) => (
  <GridToolbarExportContainer {...other}>
    <ListSubheader  className='list-subheader-item'>
      Export
    </ListSubheader>
    <GridCsvExportMenuItem options={csvOptions} />

    <GridPrintExportMenuItem options={printOptions} />
    <Divider />
    <ListSubheader  className='list-subheader-item'>
      Settings
    </ListSubheader>
    <MenuItem
      onClick={() => {
        setAction(Actions.Settings);
      }}
    >
      Display
    </MenuItem>
    {settingsMenuExtras}
  </GridToolbarExportContainer>
);

export default function PartsToolbar(props: PartsToolbarProps) {
  const {
    action,
    actions,
    clearSearch,
    csvOptions,
    defaultItems,
    enableAdvancedSearch,
    enableCreate,
    enableFilter,
    exportState,
    onChange,
    onDelete,
    printOptions,
    quickSearchItems,
    selectionModel,
    setAction,
    setSelected,
    setSelectionModel,
    setFilterButtonEl,
    currentUserId,
    value,
    name,
    setAdvanceSearchClicked,
    setFilterObj,
    ...other
  } = props;
  let navigate = useNavigate();
  const apiRef = useGridApiContext();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const [createStockOpen, setCreateStockOpen] = useState(false);
  const {
    setAdvanceSearchTriggered,
    advanceSearchTriggered,
    setFilterActive,
    filterActive,
    setAdvanceSearch,
    resetQuickFilter
  } = useDataGridStore();
  const CreateMenu = ({
    csvOptions,
    printOptions,
    setAction,

    ...other
  }) => (
    <CreateMenuOption {...other}>
      <ListSubheader style={{ color: "black", fontSize: "1rem", display: "flex" }}>
        <b>Add New</b>
      </ListSubheader>
      <MenuItem
        onClick={() => {
          navigate("create");
        }}
      >
        New Part
      </MenuItem>
      <MenuItem
        onClick={() => {
          setCreateStockOpen(true);
        }}
      >
        New Component
      </MenuItem>
      <ListSubheader style={{ color: "black", fontSize: "1rem", display: "flex" }}>
        <b>Import</b>
      </ListSubheader>
      <MenuItem
        onClick={() => {
          navigate("/components/import/basic");
        }}
      >
        Import Basic
      </MenuItem>
      <MenuItem
        onClick={() => {
          // navigate("/components/import/component")
        }}
      >
        Import Calm
      </MenuItem>
    </CreateMenuOption>
  );

  return (
    <>
      <GridToolbarContainer
        sx={{
          alignItems: "center",
          padding: (theme) => ({
            xs: theme.spacing(2, 1, 2.5),
            md: enableCreate
              ? theme.spacing(5, 6, 2.5, "50px")
              : theme.spacing(5, 6, 2.5, "50px"),
          }),
        }}
        {...other}
      >
        <>
          {selectionModel && selectionModel.length > 0 && onDelete ? (
            <IconButton
              aria-label="delete"
              onClick={() => {
                onDelete(selectionModel);
                setSelectionModel([]);
                for (const rowId of selectionModel) {
                  apiRef.current.updateRows([{ id: rowId, _action: "delete" }]);
                }
              }}
              sx={{
                position: "absolute",
                top: theme.spacing(2.5),
                left: theme.spacing(6.5),
              }}
            >
              <DeleteIcon />
            </IconButton>
          ) : (
            <>
              {enableCreate && (
                <CreateMenu
                  csvOptions={csvOptions}
                  printOptions={printOptions}
                  setAction={setAction}
                  {...other}
                />
              )}
            </>
          )}
          <ActionMenu
            actions={actions}
            setAction={setAction}
            setSelected={setSelected}
          />
          <SearchField
            value={value}
            onChange={onChange}
            clearSearch={clearSearch}
            items={quickSearchItems}
          />
          {enableFilter ? (
            <Box
              onClick={() => {
                setFilterActive(!filterActive);
               if(advanceSearchTriggered){
                  setAdvanceSearchTriggered(false);
                setAdvanceSearchClicked(false)
                setAdvanceSearch(name,[])
                }
              }}
            >
              <GridToolbarFilterButton
                ref={setFilterButtonEl}
                aria-controls="options-menu"
                aria-haspopup="true"
                disableHoverListener = {true}
                sx={getListToolbarFilterButtonSx(filterActive)}
              />
            </Box>
          ) : (
            <></>
          )}
          <Box sx={{ flex: 1 }} />
          <>
            {isSmall ? (
              <>
                {enableAdvancedSearch ? (
                  <SearchFab
                    onClick={() => {
                      props.setAction(Actions.AdvancedSearch);
                    }}
                  />
                ) : null}
              </>
            ) : (
              <>
                {enableAdvancedSearch ? (
                  <>
                    <SearchButton
                      active={advanceSearchTriggered}
                      onClick={() => {
                        props.setAction(Actions.AdvancedSearch);
                        if (!advanceSearchTriggered) {
                          setAdvanceSearchTriggered(true);
                          // setAdvanceSearchClicked(true)
                          setFilterActive(false);
                          resetQuickFilter();
                          setFilterObj(undefined);
                          apiRef.current.setFilterModel(
                            { items: defaultItems },
                            "restoreState"
                          );
                        }
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                <GridToolbarExport
                  csvOptions={csvOptions}
                  printOptions={printOptions}
                  setAction={setAction}
                  {...other}
                />
              </>
            )}
          </>
          {action === Actions.Settings ? (
            <DisplayPreferences
              onSubmit={exportState}
              open={true}
              onClose={() => {
                setAction(Actions.None);
              }}
            />
          ) : (
            <></>
          )}
        </>
      </GridToolbarContainer>
      {createStockOpen && (
        <CreateComponent
          open={createStockOpen}
          onClose={() => setCreateStockOpen(false)}
        />
      )}
    </>
  );
}
